import * as yup from 'yup';

import { strings } from '../strings';

export enum AccountInfoField {
  NAME = 'Name',
  USERNAME = 'Username',
  PASSWORD = 'Password',
  PROFILE_IMAGE = 'Profile Image',
}

export const accountInfoSchema = yup.object().shape({
  [AccountInfoField.NAME]: yup.string().min(3, strings.usernameMinCharacters),
  [AccountInfoField.USERNAME]: yup.string().min(3, strings.usernameMinCharacters),
});
